import { api } from "@/lib/api";

const post = (url, body) => api.post(url, body).then((r) => r.data);
const get = (url, params) => api.get(url, { params }).then((r) => r.data);

export const ccApi = {
  me: () => get("/mod/me"),
  searchMembers: (q) => get("/mod/members/search", { q }),
  member: (id) => get(`/mod/members/${encodeURIComponent(id)}`),
  memberAction: (id, action, body) => post(`/mod/members/${id}/${action}`, body),
  liveActive: () => get("/mod/live/active"),
  live: (id) => get(`/mod/live/${id}`),
  liveAction: (id, action, body) => post(`/mod/live/${id}/${action}`, body),
  diagnosticAccess: (id, reason) => post(`/mod/live/${id}/diagnostic-access`, { reason }),
  revokeGrant: (id) => post(`/mod/access-grants/${id}/revoke`),
  reports: (status = "open") => get("/mod/reports", { status }),
  resolveReport: (id, body) => post(`/mod/reports/${id}/resolve`, body),
  content: (type, id) => get(`/mod/content/${type}/${id}`),
  hideContent: (type, id, body) => post(`/mod/content/${type}/${id}/hide`, body),
  cases: (params) => get("/mod/cases", params),
  case: (id) => get(`/mod/cases/${id}`),
  createCase: (body) => post("/mod/cases", body),
  caseNote: (id, text) => post(`/mod/cases/${id}/notes`, { text }),
  caseStatus: (id, status, reason) => post(`/mod/cases/${id}/status`, { status, reason }),
  audit: (params) => get("/mod/audit", params),
  evidence: (params) => get("/mod/evidence", params),
  liveClip: (body) => post("/mod/evidence/live-clip", body),
  uploadScreenshot: (blob, fields) => {
    const fd = new FormData();
    fd.append("file", blob, "evidence.png");
    Object.entries(fields).forEach(([k, v]) => v != null && fd.append(k, v));
    return api.post("/mod/evidence", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  evidenceFileUrl: (id) => `${api.defaults.baseURL}/mod/evidence/${id}/file`,
  promoGrants: () => get("/owner/promo-grants"),
  promoGrant: (body) => post("/owner/promo-grants", body),
  safetyAdmins: () => get("/owner/safety-admins"),
  setSafetyAdmin: (body) => post("/owner/safety-admins", body),
};

export const errMsg = (e, fallback = "Action failed") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || fallback;
};

export const DURATIONS = [
  { label: "24h", hours: 24 }, { label: "72h", hours: 72 }, { label: "7d", hours: 168 },
  { label: "30d", hours: 720 }, { label: "Indefinite", hours: null },
];

export const fmtTs = (ts) => (ts ? new Date(ts).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");
